import { c as _c } from "react/compiler-runtime";
import { WITH_REVIEWS } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { MealConfiguration } from '@winelidays/wld-tsx-2/modules';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { lazy } from 'react';
import EntityButtons from './EntityButtons';
const InlineRating = lazy(() => import('@/components/modules/rating/InlineRating'));
const EntityInfo = lazy(() => import('./EntityInfo'));
const EntityCardDetailContentTemplate = t0 => {
    const $ = _c(33);
    const { calculatedPrice, callPrice, description, entityType, hideDescription, information, isReservation, mealConfiguration, rating, reservationInfo, showSeeMore, mapPopup, vertical, entityId, canBeGifted: t1 } = t0;
    const canBeGifted = t1 === undefined ? false : t1;
    const translate = useTranslate();
    let t2;
    if ($[0] !== showSeeMore || $[1] !== translate) {
        t2 = showSeeMore ? <Button tabIndex={-1} className="btn-ghost-primary -my-1 -ml-2" title={capitalize(translate("messages.find_out_more"))}>{capitalize(translate("messages.find_out_more"))}</Button> : null;
        $[0] = showSeeMore;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const seeMoreButton = t2;
    let t3;
    if ($[3] !== calculatedPrice || $[4] !== callPrice || $[5] !== entityType || $[6] !== information || $[7] !== isReservation || $[8] !== mapPopup || $[9] !== vertical) {
        t3 = !isReservation && <EntityInfo calculatedPrice={calculatedPrice} callPrice={callPrice} entityType={entityType} information={information} mapPopup={mapPopup} vertical={vertical}/>;
        $[3] = calculatedPrice;
        $[4] = callPrice;
        $[5] = entityType;
        $[6] = information;
        $[7] = isReservation;
        $[8] = mapPopup;
        $[9] = vertical;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    let t4;
    if ($[11] !== isReservation || $[12] !== mealConfiguration || $[13] !== translate) {
        t4 = mealConfiguration && !isReservation && <MealConfiguration drinks={mealConfiguration.drinks} formulas={mealConfiguration.formulas} translate={translate} className="text-sm my-1"/>;
        $[11] = isReservation;
        $[12] = mealConfiguration;
        $[13] = translate;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    let t5;
    if ($[15] !== isReservation || $[16] !== rating) {
        t5 = WITH_REVIEWS && !isReservation && <div className="experience-review mt-0.5 mb-1"><InlineRating {...rating} short={true} loading={false}/></div>;
        $[15] = isReservation;
        $[16] = rating;
        $[17] = t5;
    }
    else {
        t5 = $[17];
    }
    let t6;
    if ($[18] !== description || $[19] !== hideDescription || $[20] !== seeMoreButton) {
        t6 = !hideDescription && <p className="experience-description text-sm text-gray-400 mb-1 break-words"><span className="mr-2">{description}</span>{seeMoreButton}</p>;
        $[18] = description;
        $[19] = hideDescription;
        $[20] = seeMoreButton;
        $[21] = t6;
    }
    else {
        t6 = $[21];
    }
    let t7;
    if ($[22] !== canBeGifted || $[23] !== entityId || $[24] !== isReservation) {
        t7 = !isReservation ? <EntityButtons entityId={entityId} canBeGifted={canBeGifted}/> : null;
        $[22] = canBeGifted;
        $[23] = entityId;
        $[24] = isReservation;
        $[25] = t7;
    }
    else {
        t7 = $[25];
    }
    let t8;
    if ($[26] !== reservationInfo || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
        t8 = <>{reservationInfo}{t3}{t4}{t5}{t6}{t7}</>;
        $[26] = reservationInfo;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
        $[32] = t8;
    }
    else {
        t8 = $[32];
    }
    return t8;
};
export default EntityCardDetailContentTemplate;
